if (!window.customElements.get('image-hotspot')) {
  class ImageHotspot extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.content = this.querySelector('[data-image-hotspot-content]')
      this.modal = this.closest('[data-hotspots-section]')?.querySelector('[data-hotspot-section-modal]');
      this.modalCloseButton = this.modal?.querySelector('[data-hotspot-section-modal-close]');
      this.modalContent = this.modal?.querySelector('[data-hotspot-section-modal-content]');
    }

    connectedCallback() {
      if (this.button) {
        this.button.addEventListener('click', () => {
          if (window.innerWidth >= 1024) {
            this.toggleDescription();
          } else {
            this.openModal();
          }
        });
      }

      if (this.modalCloseButton) {
        this.modalCloseButton.addEventListener('click', () => this.closeModal());
      }

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || window.innerWidth >= 1024) { return; }
        this.closeModal();
      });
    }

    toggleDescription() {
      const descriptionRightPosition = this.button.getBoundingClientRect().right + 472;
      this.classList.toggle('description-left', descriptionRightPosition >= window.innerWidth);
      this.classList.toggle('active');
      this.classList.toggle('z-10');
    }

    openModal() {
      if (!this.modal) { return; }

      if (this.modalContent && this.content) {
        this.modalContent.innerHTML = this.content.innerHTML;
      }

      this.modal.classList.add('active');

      if (typeof window.trapFocus === 'function') {
        window.trapFocus(this.modal);
      }

      document.body.classList.add('overflow-hidden');
    }

    closeModal() {
      if (!this.modal) { return; }

      this.modal.classList.remove('active');

      if (typeof window.removeTrapFocus === 'function') {
        window.removeTrapFocus();
      }

      document.body.classList.remove('overflow-hidden');
    }
  }

  window.customElements.define('image-hotspot', ImageHotspot);
}
